module.exports = __webpack_public_path__ + "img/walletconnect.a720e4bd.svg";